import React, { useEffect } from "react";
import Co from "../components/Co";
import Layout from "../components/Layout";
import { FaReact } from "react-icons/fa";
import {
  SiClaude,
  SiPython,
  SiTypescript,
  SiFastapi,
  SiVercel,
  SiAmazonwebservices,
  SiCloudflare,
  SiKotlin,
  SiElasticsearch,
  SiOpenai,
  SiGmail,
  SiGooglechrome,
} from "react-icons/si";

// Every claim below comes from ai-engineering-journey/story/star/<project>/,
// software-resume/resume.tex, the Devpost pages and the public repos.
const lottie = (src) => (
  <lottie-player src={src} background="transparent" speed="1" loop autoplay></lottie-player>
);
const lottiePrev = (src) => (
  <lottie-player src={src} background="transparent" speed="1" loop autoplay style={{width: "100%", height: "100%"}}></lottie-player>
);
const A = ({ href, color, children }) => (
  <a className={`underline-offset-2 font-bold decoration-2 underline ${color}`} href={href} target="_blank" rel="noreferrer">{children}</a>
);
const Flow = ({ steps }) => (
  <span className="block mt-2 text-xs text-gray-300">{steps.join("  →  ")}</span>
);
function Projects() {
  useEffect(() => {
    window.scrollTo(0,0)
      }, [])
 
  const personal = [
    {
      title: "Music-Looper",
      features: {
        o: "Saved A-B loops on a Skia waveform",
        d: "Speed trainer that ramps tempo with pitch preserved",
        t: "Two phones sync through Cloudflare Workers in about 4 seconds",
      },
      image: lottie("https://assets-v2.lottiefiles.com/a/fb79a02a-1182-11ee-8ffe-6bd22df2bd9c/Mbmahwfm66.json"),
      description: <p><b className="text-cyan-400">Music-Looper</b> is a rehearsal app so dancers stay in flow instead of scrubbing songs and videos by hand. Built solo in React Native and TypeScript, with Kotlin where JavaScript couldn't keep up. Released on Android for internal testing with a dance studio's performance teams in under 3 months.<Flow steps={["Music phone", "Cloudflare Worker", "R2 video", "Film phone"]} /></p>,
      link: "",
      prev: lottiePrev("https://assets-v2.lottiefiles.com/a/768f5b48-a0dd-11ef-beb9-27c03ddad5a4/EGe3EwjpM8.json"),
      techs: {
        uno: <SiTypescript color="cyan" size="50" />,
        dos: <FaReact color="cyan" size="50" />,
        tres: <SiKotlin color="cyan" size="50" />,
        four: <SiCloudflare color="cyan" size="50" />,
      },
    },
    {
      title: "Job-Search Agent System",
      features: {
        o: "LLM agents read postings and track replies",
        d: "MCP tool calling for Gmail, Calendar and Chrome",
        t: "Human review approves every message",
      },
      image: lottie("https://assets4.lottiefiles.com/packages/lf20_4sabgt2r.json"),
      description: <p><b className="text-green-400">Job-Search Agent System</b> is an agentic system I'm building on Claude Code. Its LLM agents read postings and track replies through MCP tool calling for Gmail, Calendar and Chrome, with human review approving every message.<Flow steps={["Postings & inbox", "Claude Code agents", "MCP: Gmail, Calendar, Chrome", "Human review"]} /></p>,
      link: "",
      prev: lottiePrev("https://assets7.lottiefiles.com/private_files/lf30_egxsy0o3.json"),
      techs: {
        uno: <SiClaude color="cyan" size="50" />,
        dos: <SiPython color="cyan" size="50" />,
        tres: <SiGmail color="cyan" size="50" />,
        four: <SiGooglechrome color="cyan" size="50" />,
      },
    },
  ];

  // Newest first. Each links its Luma event page.
  const hackathons = [
    {
      title: "Day Trader AI",
      event: { name: "AI x Fintech Hackathon - Money Talks 2", url: "https://luma.com/aq51ak1d", date: "Oct 17, 2026" },
      features: {
        o: "Pulls every trade from a year of course videos & Discord calls",
        d: "Code checks each trade; the model never touches the money",
        t: "Backtests on 1-minute bars against holding the S&P 500",
      },
      image: lottie("https://assets8.lottiefiles.com/packages/lf20_2omr5gpu.json"),
      description: <p><b className="text-cb">Day Trader AI</b> answers one question: would copying a paid day-trading course have made money? Claude Sonnet writes down each trade, code checks it and backtests it. Learn Plan Profit turned $10,000 into $9,766, while holding the S&P 500 made $11,964. Built solo in one day at <A href="https://luma.com/aq51ak1d" color="text-yellow-500 decoration-yellow-500">Money Talks 2</A>.<Flow steps={["Videos & calls", "Claude extracts", "Code checks", "Backtest", "Verdict"]} /></p>,
      devpost: "https://devpost.com/software/day-trader-ai",
      repo: "https://github.com/Escobar-Luis/quant-bot",
      link: "https://day-trader-ai.vercel.app",
      prev: lottiePrev("https://assets5.lottiefiles.com/packages/lf20_6gfl0jjp.json"),
      techs: {
        uno: <SiClaude color="cyan" size="50" />,
        dos: <SiPython color="cyan" size="50" />,
        tres: <SiVercel color="cyan" size="50" />,
      },
    },
    {
      title: "Billing Rep",
      event: { name: "Daytona HackSprint w/ Arize AI - NYC", url: "https://luma.com/hacksprint-nyc", date: "Oct 16, 2026" },
      features: {
        o: "Reads telecom invoice PDFs with Claude on AWS Bedrock",
        d: "Checks each charge against the contract price on the bill's date",
        t: "Files a carrier inquiry only after a person approves",
      },
      image: lottie("https://assets-v2.lottiefiles.com/a/d60fc8d2-1150-11ee-8360-f7ed39ef196c/QoHIn1W35Y.json"),
      description: <p><b className="text-green-500">Billing Rep</b> is an agent that decides if a bill increase is justified before anyone pays it. Guardrails live in code, not the prompt: with no approval, the send returns 403. Team of 3 at the <A href="https://luma.com/hacksprint-nyc" color="text-yellow-500 decoration-yellow-500">Daytona HackSprint NYC</A>; I built the starter kit and the working app, 31 of our 36 commits.<Flow steps={["Invoice PDF", "Claude on Bedrock", "SurrealDB price", "Daytona math", "Approve", "File"]} /></p>,
      devpost: "https://devpost.com/software/billing-rep-ai-telecom-billing-agent",
      repo: "https://github.com/wsspang-spec/ai-billing-rep",
      link: "",
      prev: <iframe width="100%" height="100%" src="https://www.youtube.com/embed/sxglLHsEEKM" title="Billing Rep demo" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>,
      techs: {
        uno: <SiClaude color="cyan" size="50" />,
        dos: <SiAmazonwebservices color="cyan" size="50" />,
        tres: <SiFastapi color="cyan" size="50" />,
        four: <SiPython color="cyan" size="50" />,
      },
    },
    {
      title: "iMesh",
      event: { name: "Get Hired Hack @ Columbia Startup Lab", url: "https://luma.com/get-hired-hack-nyc", date: "Oct 10, 2026" },
      features: {
        o: "Voice notes and photos over a simulated LoRa mesh at 1 kbps",
        d: "Codec2 cut an 8.7-second voice clip 319x",
        t: "Code validator blocks any AI status line the data doesn't support",
      },
      image: lottie("https://assets5.lottiefiles.com/packages/lf20_6gfl0jjp.json"),
      description: <p><b className="text-sky-400">iMesh</b> sends voice notes and photos across a simulated 5-node mesh with 20% loss per hop. Whisper, GPT-4o and Claude Haiku run through one model router, and a status only reads "complete" when the far phone acks it. Built with a team of five at the <A href="https://luma.com/get-hired-hack-nyc" color="text-yellow-500 decoration-yellow-500">Get Hired Hack, Columbia Startup Lab</A>.<Flow steps={["Voice/photo", "Codec2 + transcript", "5-node mesh", "Ack", "Honest status"]} /></p>,
      devpost: "https://devpost.com/software/imesh",
      repo: "",
      link: "",
      prev: <iframe width="100%" height="100%" src="https://www.loom.com/embed/dbf20b03823c491f8e5119dd08bb1154" title="iMesh demo" frameBorder="0" allowFullScreen></iframe>,
      techs: {
        uno: <SiOpenai color="cyan" size="50" />,
        dos: <SiClaude color="cyan" size="50" />,
        tres: <SiFastapi color="cyan" size="50" />,
      },
    },
    {
      title: "Stop Complaining",
      event: { name: "AI Agents Hack Night | Mistral AI x Elasticsearch", url: "https://luma.com/nyc-hacknight", date: "Oct 7, 2026" },
      features: {
        o: "Turns a 311 complaint into the city job that fixes it",
        d: "Hybrid search over NYC jobs, 311 and payroll in Elasticsearch",
        t: "Voice input; answers cut from 58 to 9 seconds",
      },
      image: lottie("https://assets-v2.lottiefiles.com/a/a50eff4e-8bae-11ef-8581-6389f9b127b6/24y7SARjHA.json"),
      description: <p><b className="text-orange-400">Stop Complaining</b> is a Mistral agent on Elasticsearch. Say "rats on my block" and it finds the open city job that fixes it, with the posted salary and what people in that title actually earn. Meaning search alone ranked "Staff Writer" above developers, so I switched to hybrid search. Built solo in about 3 hours at the <A href="https://luma.com/nyc-hacknight" color="text-yellow-500 decoration-yellow-500">Mistral x Elastic Hack Night</A>.<Flow steps={["Complaint", "Mistral gate", "Mistral Large + 4 tools", "Elasticsearch", "Job + pay"]} /></p>,
      devpost: "https://devpost.com/software/stop-complaining",
      repo: "https://github.com/Escobar-Luis/complain-or-get-hired",
      link: "",
      prev: lottiePrev("https://assets2.lottiefiles.com/packages/lf20_lln7m43m.json"),
      techs: {
        uno: <SiElasticsearch color="cyan" size="50" />,
        dos: <SiPython color="cyan" size="50" />,
      },
    },
  ];
  return (
    <Layout>
      <div className="text-white">
        <div className="h-screen xl:pt-10 pt-[3.5rem] md:pt-0">
          {" "}
          <div className="h-3/4 " data-aos='zoom-in-up'>
            <lottie-player
              src="https://assets7.lottiefiles.com/packages/lf20_dmmkt8b9.json"
              background="transparent"
              speed="1"
              loop
              autoplay
            ></lottie-player>
          </div>
          <p data-aos='fade-right' className="xl:text-6xl lg:text-5xl md:text-xl text-8xl 2xl:text-7xl font-semibold text-center">
            {" "}
            Persistence + Creativity = Innovation
          </p>
        </div>
        <div data-aos="zoom-in" className="  font-bold text-center bg-ph mx-20 p-3 text-white rounded-tl-full rounded-br-full md:mx-5  md:p-[1rem] d xl:text-6xl lg:text-5xl md:text-2xl 2xl:text-8xl text-[8rem]">
          <h1 className="">THE KEY IS</h1>
          <h1 className="">CONSISTENCY</h1>
        </div>
      </div>
      <h1 data-aos="flip-down" className="text-7xl lg:text-5xl md:text-4xl text-white font-bold text-center mt-20">
        Personal Projects
      </h1>
      <div className="grid mt-10 md:grid-cols-1 grid-cols-2 gap-30 mx-auto md:mx-5">
        {personal.map((p) => (
          <div key={p.title} data-aos="zoom-in">
            <Co p={p}/>
          </div>
        ))}
      </div>
      <h1 data-aos="flip-down" className="text-7xl lg:text-5xl md:text-4xl text-white font-bold text-center mt-20">
        Hackathons
      </h1>
      <div className="grid mt-10 mb-20 md:grid-cols-1 grid-cols-2 gap-30 mx-auto md:mx-5">
        {hackathons.map((p) => (
          <div key={p.title} data-aos="zoom-in">
            <Co p={p}/>
          </div>
        ))}
      </div>
    </Layout>
  );
}

export default Projects;
